<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <b-card>
        <div class="row">
          <b-form-group label="Valor Solicitado *" class="col-md-3 mb-3">
            <money
              v-model="dados.valorSolicitado"
              v-bind="money"
              class="form-control"
            >
            </money>
          </b-form-group>
          <b-form-group label="Valor Limite RDV" class="col-md-3 mb-3">
            <b-form-input
              :value="$tools.converteReal(dados.valorLimiteRDV)"
              disabled
            />
          </b-form-group>
          <b-form-group label="Valor Limite Cartão" class="col-md-3 mb-3">
            <b-form-input
              :value="$tools.converteReal(dados.valorLimiteCartao)"
              disabled
            />
          </b-form-group>
          <b-form-group label="Valor Previsto" class="col-md-3 mb-3">
            <b-form-input
              :value="$tools.converteReal(dados.valorSolicitado)"
              disabled
            />
          </b-form-group>
        </div>
        <div class="row">
          <div class="d-flex">
            <div class="col-md-12">
              <div class="d-flex">
                <label class="form-label align-self-end aling-form-label"
                  >Despesas e Valores Previstos
                </label>
                <i
                  class="bx bxs-help-circle font-size-20 div-clickable"
                  @click="abrirModalDespesa"
                  style="cursor: pointer; margin-left: 5px;"
                  title="Clique para ajuda"
                />
              </div>
              <b-form-group class="col-md-12 mb-3">
                <b-form-textarea
                  v-model="dados.despesas"
                  maxlength="500"
                  @input="limitarDespesas"
                  class="form-control"
                />
              </b-form-group>
              <div class="text-center">
                <p
                  v-if="dados.despesas"
                  class="badge position-absolute"
                  :class="{
                    'bg-success': dados.despesas.length !== 500,
                    'bg-danger': dados.despesas.length === 500
                  }"
                >
                  {{ dados.despesas.length }} / 500
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex">
            <div class="col-md-12">
              <div class="d-flex">
                <label class="form-label align-self-end aling-form-label">
                  Justificativa
                </label>
                <i
                  class="bx bxs-help-circle font-size-20 div-clickable"
                  @click="abrirModalJustificativa"
                  style="cursor: pointer; margin-left: 5px;"
                  title="Clique para ajuda"
                />
              </div>
              <b-form-group class="col-md-12 mb-3">
                <b-form-textarea
                  v-model="dados.justificativa"
                  maxlength="500"
                  @input="limitarJustificativa"
                  class="form-control"
                />
              </b-form-group>
              <div class="text-center">
                <p
                  v-if="dados.justificativa"
                  class="badge position-absolute"
                  :class="{
                    'bg-success': dados.justificativa.length !== 500,
                    'bg-danger': dados.justificativa.length === 500
                  }"
                >
                  {{ dados.justificativa.length }} / 500
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mt-1 d-flex justify-content-end">
            <router-link
              :to="
                '/cooperado/rdv/carteira/adiantamento/solicitacao/' +
                  $route.params.id
              "
            >
              <b-button class="mt-1 me-1"> Voltar </b-button>
            </router-link>
            <b-button
              @click="validarSolicitacao()"
              variant="primary"
              class="mt-1"
              :disabled="loading"
            >
              Solicitar
              <b-spinner small class="ms-2" v-if="loading"></b-spinner>
            </b-button>
          </div>
        </div>
      </b-card>

      <!-- MODAL Despesas-->
      <b-modal
        v-model="showModalDespesa"
        size="lg"
        title="Informações sobre Despesas e Valores Previstos"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
      >
        <div class="d-flex justify-content-center">
          <div class="col-md-12 card">
            <div class="card-body">
              <h5 class="mt-3 mb-3 font-bold">
                Descreva as despesas e os valores que serão utilizados através
                do recurso solicitado.<br />
                Ex: (Alimentação: R$ 500,00 - Hospedagem: R$ 300,00)
              </h5>
              <div class="d-flex justify-content-end mt-4">
                <b-button variant="success" @click="fecharModalDespesa">
                  Fechar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- MODAL justificativa-->
      <b-modal
        v-model="showModalJustificativa"
        size="lg"
        title="Informações sobre Justificativa"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
      >
        <div class="d-flex justify-content-center">
          <div class="col-md-12 card">
            <div class="card-body">
              <h5 class="mt-3 mb-3 font-bold">
                Apresente a justificativa para a solicitação do recurso,
                incluindo o motivo pelo qual o valor ultrapassou o limite mensal
                estabelecido
              </h5>
              <div class="d-flex justify-content-end mt-4">
                <b-button variant="success" @click="fecharModalJustificativa">
                  Fechar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";
import { Money } from "v-money";
export default {
  components: {
    PageHeader,
    Money
  },
  data() {
    return {
      title: "Cadastro de adiantamentos",
      items: [
        {
          text: "RDV Digital"
        },
        {
          text: "Listagem de Adiantamento",
          active: false
        },
        {
          text: "Solicitação de adiantamentos",
          active: true
        }
      ],
      rdvInfo: {},
      dados: {
        valorSolicitado: "",
        valorLimiteRDV: "",
        valorLimiteCartao: "",
        valorPrevisto: "",
        justificativa: "",
        despesas: ""
      },
      loading: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },
      showModalDespesa: false,
      showModalJustificativa: false
    };
  },
  created() {
    this.buscarLimiteCartao();
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado;
    }
  },
  methods: {
    buscarLimiteCartao() {
      this.$http
        .get(
          "api/solicitacaoAdiantamento/buscarLimiteCartao/" +
            this.$route.params.id
        )
        .then(response => {
          if (!response.data[0]) {
            this.$tools.alerta(
              "Não foi encontradas informaçoes do RDV",
              "error"
            );
          }
          this.dados.valorLimiteRDV = response.data[0].vl_limite_rdv;
          this.dados.valorLimiteCartao = response.data[0].vl_limite_cartao;
        })
        .catch(err => {
          console.log(err);
        });
    },
    validarSolicitacao() {
      // let hoje = new Date(); // Obtém a data atual
      // let ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0); // Obtém o último dia do mês atual
      // let diasRestantes = ultimoDiaMes.getDate() - hoje.getDate();
      this.loading = true;
      this.$http
        .get(
          "api/solicitacaoAdiantamento/validarSolicitacao/" +
            this.$route.params.id
        )
        .then(async response => {
          var alertas = [];
          let msg = "";
          var result = response.data;
          if (result) {
            if (result.geprocoo.length == 0) {
              this.$tools.alerta(
                "Não é possivel realizar a solicitação, este projeto esta perto do fim",
                "error"
              );
              this.loading = false;
              return;
            } else {
              var index = result.geprocoo.findIndex(
                el => el.cd_projeto == this.rdvInfo.cd_projeto
              );
              if (index == -1) {
                alertas.push(3);
              }
            }
            if (result.rdv < 5) {
              msg =
                "Este RDV esta perto do final tem certeza que deseja continuar?<br>";
              alertas.push(1);
              try {
                await this.$tools.alertaConfirm(msg);
              } catch {
                this.loading = false;
                return;
              }
            }
          }
          this.loading = false;
          this.incluirSolicitacao(alertas);
        })
        .catch(err => {
          this.loading = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    },
    incluirSolicitacao(alertas) {
      if (
        !this.dados.valorSolicitado ||
        Number(this.dados.valorSolicitado) === 0
      ) {
        this.$tools.alerta("Informe o Valor Solicitado.", "error");
        this.loading = false;
        return;
      }
      this.loading = true;
      this.$http
        .post("api/solicitacaoAdiantamento/incluirSolicitacao", {
          cd_rdv: this.$route.params.id,
          vl_adiantamento: this.dados.valorSolicitado,
          ds_detalhe_uso: this.dados.despesas,
          ds_justificativa: this.dados.justificativa,
          alertas: alertas
        })
        .then(() => {
          this.loading = false;
          this.$tools.alerta(
            "Aguarde! Sua solicitação está em análise e em breve retornaremos.",
            "success"
          );
          this.$router.push(
            "/cooperado/rdv/carteira/adiantamento/solicitacao/" +
              this.$route.params.id
          );
        })
        .catch(err => {
          this.loading = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    },
    limitarDespesas() {
      if (this.dados.despesas.length > 500) {
        this.dados.despesas = this.dados.despesas.slice(0, 500);
      }
    },
    limitarJustificativa() {
      this.limitarDespesas();
    },
    abrirModalDespesa() {
      this.showModalDespesa = true;
    },
    fecharModalDespesa() {
      this.showModalDespesa = false;
    },
    abrirModalJustificativa() {
      this.showModalJustificativa = true;
    },
    fecharModalJustificativa() {
      this.showModalJustificativa = false;
    }
  }
};
</script>
